import { Phone, Mail, CheckCircle2 } from "lucide-react";
import { Reveal, PageHero, Eyebrow } from "@/components/Common";
import EnquiryForm from "@/components/EnquiryForm";
import { COMPANY } from "@/data/site";

const POINTS = [
  "Structured proposal based on your site requirement",
  "Supervised deployment with attendance management",
  "Compliance-first administration of personnel",
  "Single point of contact from enquiry to deployment",
];

const Quote = () => (
  <>
    <PageHero
      crumb="Home — Request a Quote"
      title="Request a Quote"
      subtitle="Tell us about your manpower requirement and our team will respond with a structured proposal and quotation."
    />
    <section className="py-16 sm:py-20 lg:py-24 bg-[#FAFAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2">
          <Reveal>
            <Eyebrow>How It Works</Eyebrow>
            <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-navy mt-4 leading-tight">
              From Requirement to Deployment
            </h2>
          </Reveal>
          <div className="mt-8 space-y-5">
            {POINTS.map((p, i) => (
              <Reveal key={p} delay={0.08 * i}>
                <div className="flex items-start gap-4" data-testid={`quote-point-${i + 1}`}>
                  <span className="w-8 h-8 bg-navy flex items-center justify-center shrink-0 font-heading font-bold text-gold text-xs">0{i + 1}</span>
                  <p className="text-sm text-slate-600 leading-relaxed pt-1.5">{p}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.3}>
            <div className="mt-10 bg-navy text-white p-7 relative overflow-hidden hero-grain">
              <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold">Prefer to talk directly?</p>
              <a href={COMPANY.phoneHref} className="mt-3 flex items-center gap-3 text-lg font-heading font-bold hover:text-gold transition-colors" data-testid="quote-phone-link">
                <Phone size={18} className="text-gold" /> {COMPANY.phone}
              </a>
              <a href={COMPANY.emailHref} className="mt-2 flex items-center gap-3 text-sm text-slate-300 hover:text-gold transition-colors break-all" data-testid="quote-email-link">
                <Mail size={15} className="text-gold shrink-0" /> {COMPANY.email}
              </a>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.15} className="lg:col-span-3">
          <div className="bg-white border border-slate-200 p-7 sm:p-10">
            <h2 className="font-heading text-2xl font-bold text-navy tracking-tight mb-2">Share Your Requirement</h2>
            <p className="text-sm text-slate-500 mb-8 flex items-center gap-2">
              <CheckCircle2 size={15} className="text-gold-hover" /> All fields marked * are required.
            </p>
            <EnquiryForm mode="quote" />
          </div>
        </Reveal>
      </div>
    </section>
  </>
);

export default Quote;
